import * as React from "react";

const PoiListLoading = () => {
    return (<div className="spinner"><div className="double-bounce1" /><div className="double-bounce2" /></div>);
};

export default PoiListLoading;
